import * as L from 'leaflet';

export function getPanControlOptions(afterClick: () => void): L.PM.CustomControlOptions & { disableByOtherButtons: boolean } {
  return {
    name: 'pan',
    block: 'edit',
    title: 'Verschiebe-Modus',
    afterClick,
    toggle: true,
    disableByOtherButtons: false
  };
}
